import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

export const GIFT_CARD_IMPORT_FEATURE_FLAG = 'hermes.giftCardImport'

export const checkGiftCardImportFeatureFlag: HermesGuardFn = async (to) => {
  if (to.name !== 'brand.gift-cards.import') return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled(GIFT_CARD_IMPORT_FEATURE_FLAG)) {
    return {
      name: 'brand.gift-cards',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
